export default __webpack_public_path__ + "static/media/img_baseRattle_rose.005aea1b.jpg";